module.exports = __webpack_public_path__ + "img/banner_new_4.ea949346.png";